// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"80008f27","703":"2b5964d0"}[chunkId] + ".chunk.js";
};